import * as Sentry from '@sentry/browser';
import {takeEvery, put, select} from 'redux-saga/effects';
import {moment, find, config, cookies} from 'helpers';
import {watch} from 'store/effects';
import {forbid, user} from 'store/session';
import {server} from 'store';

export function* session() {
  yield watch(user, function* (user) {
    Sentry.setUser(user);
  });

  yield watch(state => state.settings.firstDayOfWeek, function* (firstDayOfWeek = 1) { // 1 = Sunday,
    const Monday = 2;
    const locale = firstDayOfWeek == Monday ? 'en-GB' : 'en';
    moment.locale(locale);
    yield put({
      type: 'SESSION_SET_LOCALE',
      locale,
    });
  });

  yield takeEvery('SESSION_LOGOUT', function* () {
    cookies.remove('welcomed');
    window.localStorage.clear();
    if (config.development) {
      cookies.remove('token', { domain: config.appHost });
    } else {
      window.location = `https://${config.appHost}/logout/`;
    }
  });

  yield takeEvery('SERVER_DATA_RECEIVED', function* () {
    const { purchasingPlan, subscription } = yield select(state => state.session);
    if (purchasingPlan && subscription.webPlan == purchasingPlan) {
      yield put({
        type: 'SESSION_PLAN_UPGRADED',
        code: purchasingPlan,
      });
    }
  });

  yield takeEvery('SESSION_PLAN_UPGRADED', function* (action) {
    if (window.fbq) {
      const plan = find(config.plans, { code: action.code });
      window.fbq('track', 'Purchase', { value: plan.cost, currency: 'USD' });
    }
  });

  yield takeEvery('SESSION_FORBIDDEN_BY_SUBSCRIPTION', function* () {
    forbid();
  });

  yield takeEvery('*', function*({ error }) {
    //check if the token cookie is gone (expired)
    const { token } = yield select(state => state.session);
    if (token && token != cookies.get('token')) {
      yield put({
        type: 'SESSION_RESET',
      });
      yield put(server.read());
    }
    if (/incorrect security token|internal error/i.test(error)) {
      yield put({
        type: 'SESSION_LOGOUT'
      });
    }
  });
}
